// extracted by mini-css-extract-plugin
module.exports = {"md":"DebugControl_md_s0Slo","ios":"DebugControl_ios_3bnKw","debug":"DebugControl_debug_2i2CE","container":"DebugControl_container_2VzMA","active":"DebugControl_active_3rjeA"};